import {
    faInfoCircle,
    faPlus,
    faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import UnForm from "../../../../../Components/Form";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import { SendTemplateTwilioController } from "../../../../../Controllers/HelpDesk/GestaoTemplate/GestaoTemplateController";
import { ITwillioMediaType } from "../../../../../Interfaces/HelpDesk/GestaoTemplate/GestaoTemplateInterace";
import { useHistory } from "react-router-dom";
import { ACESSOS } from "../../../../../Routes/Acessos";

const tooltipMessage =
    "Clique aqui para adicionar variáveis neste campo. Variáveis permitem personalizar mensagens inserindo conteúdo dinâmico como nome de cliente ou URL única.";

// type media
export default function ContentType2() {
    const history = useHistory();

    const [bodyContent, setBodyContent] = useState("");
    const [mediaURL, setMediaURL] = useState("");
    const [variableCount, setVariableCount] = useState(0);
    const [variables, setVariables] = useState<{ [key: string]: string }>({});
    const [cursorPos, setCursorPos] = useState<number | null>(null);
    const [currentField, setCurrentField] = useState<"body" | "media" | null>(
        null
    );

    const handleBodyContentChangeInput = (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        setMediaURL(e.target.value);
    };

    const handleBodyContentChangeBody = (
        e: React.ChangeEvent<HTMLTextAreaElement>
    ) => {
        setBodyContent(e.target.value);
    };

    const handleVariableChange = (
        key: string,
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        setVariables({
            ...variables,
            [key]: e.target.value,
        });
    };

    const handleFieldFocus = (
        field: "body" | "media",
        e: React.FocusEvent<HTMLTextAreaElement | HTMLInputElement>
    ) => {
        setCurrentField(field);
        setCursorPos(e.target.selectionStart);
    };

    const insertVariable = () => {
        const newVariable = `{{${variableCount + 1}}}`;
        if (currentField === "body") {
            const textBeforeCursor = bodyContent.substring(0, cursorPos || 0);
            const textAfterCursor = bodyContent.substring(cursorPos || 0);
            setBodyContent(
                `${textBeforeCursor}${newVariable}${textAfterCursor}`
            );
        } else if (currentField === "media") {
            const textBeforeCursor = mediaURL.substring(0, cursorPos || 0);
            const textAfterCursor = mediaURL.substring(cursorPos || 0);
            setMediaURL(`${textBeforeCursor}${newVariable}${textAfterCursor}`);
        }
        setVariableCount(variableCount + 1);
        setVariables({
            ...variables,
            [newVariable]: "",
        });
    };

    const removeVariable = (variable: string) => {
        const updatedVariables = { ...variables };
        delete updatedVariables[variable];
        setVariables(updatedVariables);

        if (bodyContent.includes(variable)) {
            const updatedBodyContent = bodyContent.replace(variable, "");
            setBodyContent(updatedBodyContent);
        }

        if (mediaURL.includes(variable)) {
            const updatedMediaURL = mediaURL.replace(variable, "");
            setMediaURL(updatedMediaURL);
        }
    };

    const { execute: SendTemplateTwilio, loading: SendTemplateTwilioLoading } =
        useAsyncCallback(SendTemplateTwilioController);

    function handleText(formData: ITwillioMediaType) {
        const requestBody = {
            ...formData,
            language: "pt_BR",
            variables: variables,
        };

        const jsonString = JSON.stringify(requestBody);

        SendTemplateTwilio(jsonString, "MEDIA").then(() => {
            setBodyContent("");
            setMediaURL("");
            setVariables({});
            setVariableCount(0);
            history.push(ACESSOS.HELPDESK.TELAS.GESTAO_TEMPLATES.DS_PATH);
        });
    }

    return (
        <UnForm handleSubmit={handleText}>
            <div>
                <label>Body</label>
                <UnForm.Textarea
                    name="types.twilio/media.body"
                    className="form form-control"
                    placeholder="Digite o conteúdo do body aqui"
                    value={bodyContent}
                    onChange={handleBodyContentChangeBody}
                    onFocus={(e) => handleFieldFocus("body", e)}
                    rows={4}
                />
                <div className="d-flex justify-content-end align-items-center mt-2">
                    <button
                        className="btn"
                        type="button"
                        onClick={insertVariable}
                    >
                        + Adicionar variável
                    </button>
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip id="tooltip-top">{tooltipMessage}</Tooltip>
                        }
                    >
                        <FontAwesomeIcon icon={faInfoCircle} />
                    </OverlayTrigger>
                </div>
            </div>
            <label>Media URL</label>
            <UnForm.Input
                name="types.twilio/media.media"
                className="form form-control"
                placeholder="Digite o URL aqui"
                value={mediaURL}
                onChange={handleBodyContentChangeInput}
                onFocus={(e) => handleFieldFocus("media", e)}
            />
            <div className="d-flex justify-content-end align-items-center mt-2">
                <button className="btn" type="button" onClick={insertVariable}>
                    + Adicionar variável
                </button>
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip id="tooltip-top">{tooltipMessage}</Tooltip>
                    }
                >
                    <FontAwesomeIcon icon={faInfoCircle} />
                </OverlayTrigger>
            </div>
            <div className="mt-3">
                {Object.keys(variables).map((variable, index) => (
                    <div key={index} className="mb-2">
                        <label>{variable}</label>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                value={variables[variable]}
                                onChange={(e) =>
                                    handleVariableChange(variable, e)
                                }
                                required
                            />
                            <div className="input-group-append">
                                <button
                                    className="btn btn-outline-danger"
                                    type="button"
                                    onClick={() => removeVariable(variable)}
                                >
                                    <FontAwesomeIcon icon={faTrash} />
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <hr className="my-5 " />

            <div className="d-flex justify-content-start">
                <div>
                    <UnForm.SubmitButton
                        icon={faPlus}
                        disabled={SendTemplateTwilioLoading}
                        loading={SendTemplateTwilioLoading}
                        loadingSize="sm"
                        wrapperClassName="m-0"
                        color="success"
                    >
                        Criar
                    </UnForm.SubmitButton>
                </div>
                <div>
                    <button
                        className="btn btn-secondary ml-2"
                        type="button"
                        onClick={() => {
                            history.push(
                                ACESSOS.HELPDESK.TELAS.GESTAO_TEMPLATES_TWILIO
                                    .DS_PATH
                            );
                        }}
                    >
                        Cancelar
                    </button>
                </div>
            </div>
        </UnForm>
    );
}
